import { useUIContext } from "common/uicontext/store";
import { EventState } from "../../entity";
import { useEventPlanning_Event } from "./store";
export var GetEditPermissions = function () {
    var event_state = useEventPlanning_Event()[0];
    var uicontext_state = useUIContext()[0];
    var _a = uicontext_state.data.event_planning, isOrganizer = _a.isOrganizer, isCompetitionCommissioner = _a.isCompetitionCommissioner, isCompetitionLead = _a.isCompetitionLead, isSecretary = _a.isSecretary, isSportVicepresident = _a.isSportVicepresident;
    var EC = event_state.entity.eventCompetitions[0];
    var dateNow = new Date();
    var P = {
        Action: false,
        Running: false,
        Information: false,
        Secretary: false,
        Definition: false,
        //VoS: false,
        r01_dances: false,
        r02_removeCompetitions: false,
        r03_date: false,
        r04_addOrModifyCompetitions: false,
        r05_judgesAndOfficials: false,
        a1_foreignAdjudicatorApproval: false,
        a2_requestApproval: false,
        a3_withdraw: false,
        a4_approve: false,
        a5_disapprove: false,
        a6_return: false,
        a7_cancel: false,
        a8_revive: false,
        a9_publish: false,
    };
    if (EC) {
        // without overlap
        var nowIsBeforeCancelationDeadline = dateNow < EC.competitionCancelDeadline;
        var nowIsBeforeRegistrationDeadline = dateNow < EC.registrationDeadline && !nowIsBeforeCancelationDeadline;
        var nowIsBeforeCheckInTimesDeadline = dateNow < EC.registrationTimesDeadline && !nowIsBeforeCancelationDeadline && !nowIsBeforeRegistrationDeadline;
        var nowIsAfterCheckInTimesDeadline = !nowIsBeforeCancelationDeadline && !nowIsBeforeRegistrationDeadline && !nowIsBeforeCheckInTimesDeadline;
        var isPrivate = EC.state === EventState.Private;
        var isWaiting = EC.state === EventState.Waiting;
        var isApproved = EC.state === EventState.Approved;
        var isPublic = EC.state === EventState.Public;
        var isCancelled = EC.state === EventState.Cancelled;
        // without overlap
        var isPublicBeforeCancelationDL = isPublic && nowIsBeforeCancelationDeadline;
        var isPublicBeforeRegistrationDL = isPublic && nowIsBeforeRegistrationDeadline;
        var isPublicBeforePresenceTimesDL = isPublic && nowIsBeforeCheckInTimesDeadline;
        var isPublicAfterPresenceTimesDL = isPublic && nowIsAfterCheckInTimesDeadline;
        // Rights for roles with backups
        var hasActionRightsLevel = isCompetitionCommissioner || isSportVicepresident;
        var hasRunningRightsLevel = isCompetitionLead || isCompetitionCommissioner;
        var hasInformationRightsLevel = isOrganizer || isCompetitionLead;
        var hasDefinitionRightsLevel = isCompetitionCommissioner || isSportVicepresident;
        var hasSecretaryRightsLevel = isSecretary;
        var hasVoSRightsLevel = isSportVicepresident;
        if (dateNow < EC.excuseDeadline || !isPublic) { // A reasonable deadline for modifications.
            ////
            if (isPrivate) {
                if (hasInformationRightsLevel) {
                    P.Action = P.Running = P.Information = true;
                }
                if (hasVoSRightsLevel) {
                    P.Action = true;
                }
            }
            if (isWaiting) {
                if (hasActionRightsLevel) {
                    P.Action = P.Running = true;
                }
                if (hasInformationRightsLevel) {
                    P.Information = P.r01_dances = P.r02_removeCompetitions = true;
                }
            }
            if (isApproved) {
                if (hasActionRightsLevel) {
                    P.Action = true;
                }
                if (hasRunningRightsLevel) {
                    P.Running = true;
                }
                if (hasInformationRightsLevel) {
                    P.Information = P.r01_dances = P.r02_removeCompetitions = true;
                }
                if (hasSecretaryRightsLevel) {
                    P.Secretary = true;
                }
            }
            if (isPublic) {
                if (isPublicBeforeCancelationDL) {
                    if (hasActionRightsLevel) {
                        P.Action = true;
                    }
                    if (hasRunningRightsLevel) {
                        P.Running = true;
                    }
                    if (hasInformationRightsLevel) {
                        P.Information = P.r01_dances = P.r02_removeCompetitions = true;
                    }
                    if (hasSecretaryRightsLevel) {
                        P.Secretary = true;
                    }
                }
                if (isPublicBeforeRegistrationDL) {
                    if (hasActionRightsLevel) {
                        P.Action = true;
                    }
                    if (hasRunningRightsLevel) {
                        P.Running = true;
                    }
                    if (hasInformationRightsLevel) {
                        P.Information = P.r01_dances = true;
                    }
                    if (hasSecretaryRightsLevel) {
                        P.Secretary = true;
                    }
                }
                if (isPublicBeforePresenceTimesDL) {
                    if (hasActionRightsLevel) {
                        P.Action = P.r04_addOrModifyCompetitions = true;
                    }
                    if (hasRunningRightsLevel) {
                        P.Running = true;
                    }
                    if (hasInformationRightsLevel) {
                        P.Information = true;
                    }
                    if (hasSecretaryRightsLevel) {
                        P.Secretary = true;
                    }
                }
                if (isPublicAfterPresenceTimesDL) {
                    if (hasActionRightsLevel) {
                        P.Action = P.r04_addOrModifyCompetitions = true;
                    }
                    if (hasRunningRightsLevel) {
                        P.r05_judgesAndOfficials = true;
                    }
                    if (hasInformationRightsLevel) {
                        P.Information = true;
                    }
                    if (hasSecretaryRightsLevel) {
                        P.Secretary = true;
                    }
                }
            }
            //// Actions
            if (isPrivate) {
                if (hasInformationRightsLevel) {
                    P.a2_requestApproval = P.a7_cancel = true;
                }
            }
            if (isWaiting) {
                if (hasInformationRightsLevel) {
                    P.a3_withdraw = P.a7_cancel = true;
                }
                if (hasActionRightsLevel) {
                    P.a4_approve = P.a5_disapprove = true;
                }
                //todo Publish if already has been public?
            }
            if (isApproved) {
                if (hasInformationRightsLevel) {
                    P.a3_withdraw = P.a7_cancel = true;
                }
                if (hasActionRightsLevel) {
                    P.a6_return = true;
                }
                if (hasSecretaryRightsLevel) {
                    P.a9_publish = true;
                }
            }
            if (isPublic) {
                if (isPublicBeforeCancelationDL) {
                    if (hasInformationRightsLevel) {
                        P.a7_cancel = true;
                    }
                }
                if (hasActionRightsLevel) {
                    P.a7_cancel = P.a6_return = true;
                }
                if (isPublicBeforeRegistrationDL) {
                }
                if (isPublicBeforePresenceTimesDL) {
                }
                if (isPublicAfterPresenceTimesDL) {
                }
            }
            if (isCancelled) {
                if (hasSecretaryRightsLevel) {
                    P.a8_revive = true;
                }
            }
            ////
            if (P.Action === true) {
                P.Definition = true;
            }
        }
    }
    return P;
};
